"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItemLabel = void 0;
exports.searchUserFactory = searchUserFactory;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var getItemLabel = exports.getItemLabel = function getItemLabel(identity) {
  switch (identity.identityType) {
    case 'team':
      return identity.name;
    case 'user':
      return "".concat(identity.firstName, " ").concat(identity.lastName, " (").concat(identity.username, ")");
    default:
      return 'Unspecified identity';
  }
};
function searchUserFactory(_ref) {
  var onSearch = _ref.onSearch,
    loggedUserId = _ref.loggedUserId;
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
      var query, limit, offset, newQuery, identities, identitiesWithoutCurrentUser;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            query = _ref2.query, limit = _ref2.limit, offset = _ref2.offset;
            newQuery = {
              search: query,
              limit: limit,
              offset: offset
            };
            _context.next = 4;
            return onSearch(newQuery);
          case 4:
            identities = _context.sent;
            identitiesWithoutCurrentUser = identities.filter(function (identity) {
              return identity.id !== loggedUserId;
            });
            return _context.abrupt("return", identitiesWithoutCurrentUser.map(function (identity) {
              return {
                identity: identity,
                label: getItemLabel(identity),
                search: query
              };
            }));
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}
//# sourceMappingURL=AutocompleteUtils.js.map